import http from "../api/apiClient";

/**
 * POST /child-classrooms/assign (controller expects @RequestParam)
 *
 * Compat:
 *   assignChildToClassroom(token, childId, classroomId, setChildren?, grade?, setCurrent?)
 *
 * New:
 *   assignChildToClassroom(null, childId, classroomId, { grade, setCurrent }, setChildren?)
 */
const assignChildWithEndpoint = async (
  endpoint,
  endpointLabel,
  _token,
  childId,
  classroomId,
  arg4 = undefined,
  arg5 = undefined,
  arg6 = undefined
) => {
  if (!childId || !classroomId) {
    const msg = "❌ Missing childId or classroomId";
    console.error(msg);
    throw new Error(msg);
  }

  // overload-resolutie
  let setChildren = null;
  let grade = null;        // number | null
  let setCurrent = true;   // default

  if (typeof arg4 === "function") {
    // Oude signature
    setChildren = arg4 || null;
    grade = arg5 ?? null;
    setCurrent = arg6 === undefined ? true : !!arg6;
  } else if (arg4 && typeof arg4 === "object") {
    // Nieuwe signature
    grade = arg4.grade ?? null;
    setCurrent = arg4.setCurrent === undefined ? true : !!arg4.setCurrent;
    if (typeof arg5 === "function") setChildren = arg5;
  }

  // Als grade ontbreekt → haal classroom op en leid af
  let derivedGrade = grade;
  if (derivedGrade === null || derivedGrade === undefined) {
    try {
      const { data: cls } = await http.get(`/classrooms/${encodeURIComponent(classroomId)}`);
      if (typeof cls?.grade === "number") {
        derivedGrade = cls.grade;
      } else {
        // Parse cijfer uit naam (bv. "Klas 2", "Grade 3")
        const m = String(cls?.className || "").match(/(\d{1,2})/);
        derivedGrade = m ? Number(m[1]) : 0; // kindergarten of onbekend → 0
      }
    } catch (e) {
      console.warn("⚠️ Could not fetch classroom to infer grade. Defaulting to 0.", e?.response?.data || e?.message);
      derivedGrade = 0;
    }
  }

  // params (géén body)
  const params = {
    childId,
    classroomId,
    setCurrent: setCurrent ? "true" : "false",
    grade: String(Number(derivedGrade) || 0), // forceer altijd een nummer
  };

  try {
    const { data } = await http.post(endpoint, null, { params });

    // Optimistic UI
    if (typeof setChildren === "function") {
      setChildren((prev) =>
        Array.isArray(prev)
          ? prev.map((c) => (c.id === childId ? { ...c } : c))
          : prev
      );
    }
    return data;
  } catch (error) {
    const body = error?.response?.data;
    console.error(`❌ Error assigning (${endpointLabel}):`, body || error?.message);
    const err = new Error(body?.message || body?.error || error?.message || "Internal Server Error");
    err.status = error?.response?.status;
    err.details = body;
    throw err;
  }
};

export const assignChildToClassroom = async (
  _token,
  childId,
  classroomId,
  arg4 = undefined,
  arg5 = undefined,
  arg6 = undefined
) => assignChildWithEndpoint(
  "/child-classrooms/assign",
  "POST /child-classrooms/assign",
  _token,
  childId,
  classroomId,
  arg4,
  arg5,
  arg6
);

export const placeChildFromWaitingList = async (
  _token,
  childId,
  classroomId,
  arg4 = undefined,
  arg5 = undefined,
  arg6 = undefined
) => assignChildWithEndpoint(
  "/child-classrooms/place-from-waiting-list",
  "POST /child-classrooms/place-from-waiting-list",
  _token,
  childId,
  classroomId,
  arg4,
  arg5,
  arg6
);
